import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {
    async promotionApply({}, args) {
      return await window.$axios.get('product/' + args.productId, {
        params: {
          promotion_code: args.code,
          company_type_id: args.companyTypeId,
          product_ids: args.productId,
        },
      });
    },
    async multiplePromotionAppliable({}, args) {
      return await window.$axios.post('promotion/products?include=appliedPromotionCode', {
        promotion_codes: args.promotions,
        company_type_id: args.companyTypeId,
        product_ids: args.productId,
      });
    },
    async getInstallments({}, args) {
      return await window.$axios.post('card/installment', {
        bin_number: args.bin_number,
        price: args.price,
        id: args.id,
      });
    },
  },
  getters: {},
});
